<template lang="pug">
  div
    #app
      MyHeader
      .wrapper.m-t-20
        router-view
</template>

<style lang="scss">
body,html {
  height: 100%;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Segoe UI', YuGothic, 'Yu Gothic Medium', 'Hiragino Sans', 'Hiragino Kaku Gothic ProN', Meiryo, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.text-lg {
  font-size: 120%;
  font-weight: bold;
}

.text-xl {
  font-size: 150%;
  font-weight: bold;
}

.text-ul {
  font-size: 180%;
  font-weight: bold;
}

table.table-middle {
  tr {
    th, td {
      vertical-align: middle;
    }
  }
}

input.form-control::placeholder {
  color: #cccccc;
}

input:focus::-webkit-input-placeholder { color:transparent; }
input:focus:-moz-placeholder { color:transparent; } /* FF 4-18 */
input:focus::-moz-placeholder { color:transparent; } /* FF 19+ */
input:focus:-ms-input-placeholder { color:transparent; } /* IE 10+ */

* { text-transform: none !important }

.site-title {
  font-weight: bold;
}

.page-title {
  font-size: 20px;
  font-weight: bold;
}
</style>

<script>
import MyHeader from '@/components/Header'

export default {
  components: {
    MyHeader,
  }
}
</script>